export default __webpack_public_path__ + "static/media/warren-logo.1de4cd65.svg";